export default __webpack_public_path__ + "static/media/file-text.53ed6a7e.svg";